import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('MAIN_BOOKMAKER_MAPPINGS_BY_COMPETITION');
